import axios from 'axios'

const axiosInstance = axios.create()

const getStoredToken = () => {
    const token = window.localStorage.getItem('accessToken')
    if (!token || token === 'undefined' || token === 'null') {
        return null
    }
    return token
}

axiosInstance.interceptors.request.use((config) => {
    const token = getStoredToken()
    config.headers = config.headers || {}

    // Always prefer the latest stored token; drop stale manual headers
    if (config.headers.authorization) {
        delete config.headers.authorization
    }
    if (config.headers.Authorization) {
        delete config.headers.Authorization
    }

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (
            axios.isCancel?.(error) ||
            error?.code === 'ERR_CANCELED' ||
            error?.name === 'CanceledError' ||
            error?.message === 'canceled'
        ) {
            return Promise.reject(error)
        }

        const data = error.response?.data
        const status = error.response?.status

        if (data && typeof data === 'object') {
            return Promise.reject({ ...data, status })
        }

        return Promise.reject({
            message:
                typeof data === 'string' ? data : 'Something went wrong!',
            status,
        })
    }
)

export default axiosInstance
